// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".300dda07c939a9e2b06f2ef3b28c31a3ca9d85ba.chunk.bundle.js";
};